import { useMemo } from "react";
import { InputFieldProps } from "../types";
import {
  duplicateDataMessages,
  incompleteDataMessage,
  incompleteRowIndexes,
} from "./duplicateDataMessage";

// Per-row checks of FieldsGroupWrapper, all based on importantFields:
// duplicate / built-in warnings, and half-filled rows with their "provided together" message.
export const useRowChecks = (
  fieldRender: InputFieldProps[][],
  importantFields: string[],
  builtInValues?: string[],
) => {
  const fieldDuplicateWarnings = useMemo(
    () => duplicateDataMessages(fieldRender, importantFields, builtInValues),
    [fieldRender, importantFields, builtInValues],
  );

  // The "provided together" rule only exists with several importantFields.
  const completenessMessage = useMemo(
    () =>
      importantFields.length > 1
        ? incompleteDataMessage(importantFields)
        : undefined,
    [importantFields],
  );

  const incompleteRows = useMemo(
    () => incompleteRowIndexes(fieldRender, importantFields),
    [fieldRender, importantFields],
  );

  return { fieldDuplicateWarnings, completenessMessage, incompleteRows };
};
